export default __webpack_public_path__ + "static/media/logo-wording.cbec6ee8.png";